// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c16fd99e","455":"149720bf","977":"ddecb097"}[chunkId] + ".chunk.js";
};